import React from 'react';
import PropTypes from 'prop-types';

const HomeSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 16}`}
      height={`${height || 16}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.0135 1.89336L2.42016 4.69336C1.82016 5.16003 1.3335 6.15336 1.3335 6.90669V11.8467C1.3335 13.3934 2.5935 14.66 4.14016 14.66H11.8602C13.4068 14.66 14.6668 13.3934 14.6668 11.8534V7.00003C14.6668 6.19336 14.1268 5.16003 13.4668 4.70003L9.34683 1.81336C8.4135 1.16003 6.9135 1.19336 6.0135 1.89336Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 11.9933V9.99335"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

HomeSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default HomeSvg;
